import { gql } from '@parkchirp/api-client';

export const GET_CREDIT_DETAILS = gql`
    query getCreditDetails($creditId: String!) {
        getCreditDetails(creditId: $creditId) {
            id
            creditId
            amount
            balance
            paymentId
            paymentType
            applicationType
            creditDate
            billingName
            notes
            primaryContact
            subscriptionName
            subscriptionNameFormatted
            accountId
            facilityId
            facilityName
            facilityTimezone
            paymentGroupId
            firstApplicationDate
            futureMonthApplication
            earliestPaymentApplicationDate
            latestPaymentApplicationDate
        }
    }
`;

export const GET_CREDIT_HISTORY = gql`
    query getCreditHistory($creditId: String!) {
        getCreditHistory(creditId: $creditId) {
            id
            applicationType
            transactionDate
            invoiceNumber
            applicationDate
            creditTypeLabel
            amount
            amountTax1
            amountTax2
            amountTax3
            amountTax4
            grossAmount
            paymentBatches
        }
    }
`;

export const GET_CREDIT_BALANCES = gql`
    query GetCreditBalances($creditId: String!) {
        getCreditBalances(creditId: $creditId) {
            id
            amount
            amountTax1
            amountTax2
            amountTax3
            amountTax4
            grossAmount
        }
    }
`;
